module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "level1 hidden",
    attrs: {
      "data-number": "2",
      "epub:type": "preface",
      "id": "preface"
    }
  }, [_c('h1', {
    staticClass: "hidden",
    attrs: {
      "data-number": "2",
      "epub:type": "preface"
    }
  }, [_vm._v("Preface")]), _vm._v(" "), _c('p', {
    staticClass: "no_header"
  }, [_vm._v("The story of Emain Macha, the palace of Conor the Great King of Ulster and the home of the Heroes of the Red Branch; and of Cuchullain, the Hound of Cullan; and Leary, his charioteer.")]), _vm._v(" "), _c('p', [_vm._v("Especially his charioteer, born Sigmund the German, brought to Rome as a hostage by Tiberius, washed up onto Ulster.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab9d586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 69
// module chunks = 0